module.exports = __webpack_public_path__ + "img/s3e1.e7dfcd90.svg";